import { render, staticRenderFns, recyclableRender, components } from "./freight.vue?vue&type=template&id=2fc0a58e&scoped=true&"
var renderjs
import script from "./freight.vue?vue&type=script&lang=js&"
export * from "./freight.vue?vue&type=script&lang=js&"
import style0 from "./freight.vue?vue&type=style&index=0&lang=css&"
import style1 from "./freight.vue?vue&type=style&index=1&id=2fc0a58e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../办公/HBuilderX.3.8.12.20230817/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc0a58e",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/freight/freight.vue"
export default component.exports